import { Radio } from '@dextech-ai/dex-design-system';
import PropTypes from 'prop-types';

// DS Radio shown as a selector tile's state marker. The tile is the click
// target, so the radio takes no keyboard input of its own. It keeps pointer
// events so the DS hover state shows; antd's label already stops the input's
// repeat click, so the tile still sees one click.
const SelectorBoxRadio = ({ active = false }) => (
	<span className="selector-box-3__radio" aria-hidden="true">
		<Radio
			value="selected"
			checked={!!active}
			tabIndex={-1}
		/>
	</span>
);

SelectorBoxRadio.propTypes = {
	active: PropTypes.bool,
};

export default SelectorBoxRadio;
